import { render } from "./payout-order-page.vue?vue&type=template&id=1acd1699&ts=true"
import script from "./payout-order-page.ts?vue&type=script&lang=ts"
export * from "./payout-order-page.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__